<template>
  <div
    v-if="accountConfirmed"
    class="columns is-centered content"
  >
    <div class="column is-6">
      <div class="box">
        <div>
          <div class="columns">
            <div class="column has-text-centered">
              <h2 class="title is-2">
                Account Confirmed
              </h2>
            </div>
          </div>
          <div class="columns">
            <div class="column has-text-centered">
              <p>You have successfully confirmed your account. Click on the button below to login.</p>
              <br>
              <router-link :to="{ name: 'login' }">
                <button
                  id="modal-login-btn"
                  type="button"
                  class="button is-primary"
                >
                  Login
                </button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    v-else
    class="columns is-centered"
  >
    <div class="column is-6">
      <div class="box">
        <div>
          <div class="columns">
            <div class="column has-text-centered">
              <h2 class="title is-2">
                Expired link!
              </h2>
            </div>
          </div>
          <div class="columns">
            <div class="column has-text-centered">
              <p>The link you are using has expired. Please contact support if you are having issues activating your account.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AccountConfirmation',
  data() {
    return {
      accountConfirmed: false,
    };
  },
  async created () {
    let data = {
      filerId: this.$route.query.filerId,
      emailToken: this.$route.query.emailToken,
    };

    if (data.filerId && data.emailToken) {
      this.$store.dispatch('login/confirmAccountToken', data).then(() => {
        this.accountConfirmed = true;
      });
    }
  },
};
</script>
